import { render, staticRenderFns } from "./loginTypeConfiguration.vue?vue&type=template&id=0f4c26ea&scoped=true&"
import script from "./loginTypeConfiguration.vue?vue&type=script&lang=js&"
export * from "./loginTypeConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c26ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4c26ea')) {
      api.createRecord('0f4c26ea', component.options)
    } else {
      api.reload('0f4c26ea', component.options)
    }
    module.hot.accept("./loginTypeConfiguration.vue?vue&type=template&id=0f4c26ea&scoped=true&", function () {
      api.rerender('0f4c26ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/loginTypeConfiguration.vue"
export default component.exports